<script lang="ts">
export default {
  name: 'CanvasActions',
  components: {
    GridToggle,
    SnapToToggle,
    ExportButton,
    LegendToggle,
    LimitPremiumCounterToggle,
    HelpCircle,
  },
};
</script>

<script setup lang="ts">
import GridToggle from './GridToggle.vue';
import SnapToToggle from './SnapToToggle.vue';
import ExportButton from '@/views/tower/v2/ExportButton.vue';
import LegendToggle from '@/views/tower/v2/LegendToggle.vue';
import LimitPremiumCounterToggle from './LimitPremiumCounterToggle.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { AppState } from '@/store';
import ExportList from '@/views/tower/v2/ExportList.vue';
import { HelpCircle } from 'lucide-vue-next';

const store = useStore<AppState>();
const isPanelOpen = computed(() => store?.state.towerCanvasState.programsPanelState.show);
</script>

<template>
  <div
    class="tw:row-start-2 tw:col-start-2 tw:col-span-2 tw:justify-self-end tw:flex tw:flex-col tw:justify-end tw:mr-2"
    :class="{ 'tw:!col-start-2 tw:mr-96 tw:justify-self-center tw:lg:justify-self-end': isPanelOpen }"
  >
    <ExportList class="tw:mr-2" />
    <div class="tw:flex tw:h-14 tw:gap-1">
      <SnapToToggle />
      <LegendToggle />
      <GridToggle />
      <LimitPremiumCounterToggle />
      <ExportButton />
      <a
        href="https://cobbs-allen.sharefile.com/f/fodf52cc-2817-4922-bf95-8473a458c56a"
        target="_blank"
        title="Help"
        class="tw:pointer-events-auto tw:flex tw:items-center tw:text-sm tw:text-gray-500 tw:font-medium tw:ml-2 tw:cursor-pointer tw:self-center tw:hover:scale-110 tw:transition-all tw:duration-75"
      >
        <HelpCircle
          class="tw:ml-2 tw:self-center tw:transition-all tw:hover:stroke-lime-600"
        />
      </a>
    </div>
  </div>
</template>
